import { render, staticRenderFns } from "./PendingApprovalWorkOrder.vue?vue&type=template&id=6d6f61a9"
import script from "./PendingApprovalWorkOrder.vue?vue&type=script&lang=ts"
export * from "./PendingApprovalWorkOrder.vue?vue&type=script&lang=ts"
import style0 from "./PendingApprovalWorkOrder.vue?vue&type=style&index=0&id=6d6f61a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports